// src/Dashboard.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
import axios from "./axiosConfig"; // adjust path if needed
import './Dashboard.css';

function Dashboard() {
  const [hasUnread, setHasUnread] = useState(false);
  const user = JSON.parse(localStorage.getItem('user'));
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate('/login');
  };

  useEffect(() => {
    const fetchUnreadMessages = async () => {
      if (user?.id && user?.role !== 'admin') {
        try {
          // const response = await axios.get(
          //   `http://localhost:8080/api/admin-messages/unread?receiverId=${user.id}`
          // );
          const response = await axios.get(
            `/api/admin-messages/unread?receiverId=${user.id}`
          );
          if (response.data.length > 0) {
            setHasUnread(true);
          }
        } catch (error) {
          console.error('Error fetching unread messages:', error);
        }
      }
    };

    fetchUnreadMessages();
  }, [user]);

  return (
    <body>
      <div className="dashboard-container">
        <header className="dashboard-header">
          <h1>AdoptLink</h1>
          <button className="logout-button" onClick={handleLogout}>
            Logout
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h280v80H200Zm440-160-55-58 102-102H360v-80h327L585-622l55-58 200 200-200 200Z"/></svg>
          </button>
        </header>

        <main className="dashboard-main">
          <h2>👋 Welcome, {user?.name || 'Guest'}
            <br />
            <br />
          {/* <img src="https://media.istockphoto.com/id/1255163297/vector/user-profile-icon-vector-avatar-portrait-symbol-flat-shape-person-sign-logo-black-silhouette.jpg?s=612x612&w=0&k=20&c=p6azyhUBIcWx6-aXVRPUTveaVqbTA2bNXpBoGQjEB68=" title='Your Profile' alt="Submit" width="48" height="48" onClick={() => navigate('/profile')}></img> */}
          </h2>
          <div className="dashboard-buttons">
            {/* Common for all users */}
            <button onClick={() => navigate('/rescue-posts')}>Rescue Posts</button>
            <button onClick={() => navigate('/adoption-posts')}>Animals for Adoption</button>
            <button onClick={() => navigate('/profile')}>Your Profile</button>
            {/* <img src="https://media.istockphoto.com/id/1255163297/vector/user-profile-icon-vector-avatar-portrait-symbol-flat-shape-person-sign-logo-black-silhouette.jpg?s=612x612&w=0&k=20&c=p6azyhUBIcWx6-aXVRPUTveaVqbTA2bNXpBoGQjEB68=" alt="Submit" width="48" height="48" onClick={() => navigate('/profile')}></img> */}
            <button onClick={() => navigate('/post-animal')}>📤 Post Animal</button>
            <button onClick={() => navigate('/my-requests')}>My Adoption Requests</button>
            <button onClick={() => navigate('/incoming-requests')}>Incoming Requests</button>
            
            
            
            {/* ✅ Message Admin with unread notification */}
            {user?.role !== 'admin' && (
              <button onClick={() => navigate('/messages/admin')}>
                💬 Message Admin {hasUnread && <span className="notification-dot">🔴</span>}
              </button>
            )}

            {/* Admin-only buttons */}
            {user?.role === 'admin' && (
              <>
                {/* <hr /> */}
                <br />
                <br />
                <h3>🛠 Admin Panel</h3>
                <button onClick={() => navigate('/admin/users')}>👥 View All Users</button>
                <button onClick={() => navigate('/admin/achievements')}>🏆 View Achievements</button>
                <button onClick={() => navigate('/admin/moderate-posts')}>🛠 Moderate Posts</button>
              </>
            )}
          </div>
        </main>
        
        <footer>
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="#FFFFFF" onClick={() => navigate('/profile')}><path d="M222-255q63-44 125-67.5T480-346q71 0 133.5 23.5T739-255q44-54 62.5-109T820-480q0-145-97.5-242.5T480-820q-145 0-242.5 97.5T140-480q0 61 19 116t63 109Zm257.81-195q-57.81 0-97.31-39.69-39.5-39.68-39.5-97.5 0-57.81 39.69-97.31 39.68-39.5 97.5-39.5 57.81 0 97.31 39.69 39.5 39.68 39.5 97.5 0 57.81-39.69 97.31-39.68 39.5-97.5 39.5Zm.66 370Q398-80 325-111.5t-127.5-86q-54.5-54.5-86-127.27Q80-397.53 80-480.27 80-563 111.5-635.5q31.5-72.5 86-127t127.27-86q72.76-31.5 155.5-31.5 82.73 0 155.23 31.5 72.5 31.5 127 86t86 127.03q31.5 72.53 31.5 155T848.5-325q-31.5 73-86 127.5t-127.03 86Q562.94-80 480.47-80Zm-.47-60q55 0 107.5-16T691-212q-51-36-104-55t-107-19q-54 0-107 19t-104 55q51 40 103.5 56T480-140Zm0-370q34 0 55.5-21.5T557-587q0-34-21.5-55.5T480-664q-34 0-55.5 21.5T403-587q0 34 21.5 55.5T480-510Zm0-77Zm0 374Z" /></svg>
          </div>

          <div>
            <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="#FFFFFF"><path d="M240-399h313v-60H240v60Zm0-130h480v-60H240v60Zm0-130h480v-60H240v60ZM80-80v-740q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H240L80-80Zm134-220h606v-520H140v600l74-80Zm-74 0v-520 520Z"/></svg>
          </div>

          <div>
            <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="#FFFFFF"><path d="M165-226q-39-45-58.5-100T80-440h62q8 46 24 89t45 80l-46 45ZM80-520q9-58 29-113t56-101l46 45q-29 37-45 80t-24 89H80ZM438-82q-58-7-113-27t-101-56l45-47q38 27 80.5 45t88.5 25v60ZM272-748l-48-47q47-36 102.5-56T441-878v60q-46 7-89 24.5T272-748ZM518-82v-60q47-7 90-25.5t82-44.5l47 47q-47 37-103 56.5T518-82Zm174-666q-38-27-81-45t-90-25v-60q59 7 113.5 27.5T737-795l-45 47Zm104 522-45-45q28-37 44-80t24-89h62q-9 58-28.5 113T796-226Zm23-294q-8-46-24-89t-44-80l45-45q39 45 58.5 100T881-520h-62ZM450-280v-284L323-437l-43-43 200-200 200 200-43 43-127-127v284h-60Z"/></svg>
          </div>

          <div>
            <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="#FFFFFF"><path d="M527-502ZM480-80q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80ZM160-200v-60h80v-304q0-84 49.5-150.5T420-798v-22q0-25 17.5-42.5T480-880q25 0 42.5 17.5T540-820v22q32 7 59.5 22.5T649-738l-44 45q-24-23-56.5-37T480-744q-75 0-127.5 52.5T300-564v304h500v60H160Zm508-231-41-41q16-16 24.5-36.5T660-552q0-23-8-44t-23-36l40-41q25 25 38 56t13 65q0 33-13.5 64.5T668-431Zm44 44q32-29 50-71t18-93q0-49-18-92t-50-73l44-44q41 41 62.5 95T840-551q0 60-21.5 113.5T756-343l-44-44Z"/></svg>
          </div>
        </footer>
        
      </div>
    </body>
  );
}

export default Dashboard;
